import React from 'react'
import styled from 'styled-components'

const StyledEditLink = styled.a`
  :focus {
    border-bottom: 1px solid;
  }

  :hover {
    border-bottom: 1px solid;
  }
`

interface EditLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: React.ReactNode
}

export const EditLink: React.FC<EditLinkProps> = ({
  href,
  children,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    // Open without 'noopener' so window.close() can work reliably
    // Keep 'noreferrer' for privacy
    window.open(href, '_blank', 'noreferrer')
  }

  return (
    <StyledEditLink href={href} onClick={handleClick} {...props}>
      {children}
    </StyledEditLink>
  )
}

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  width: calc(100vw - 64px);
  align-items: space-between;
  align: center;
`
